export default "__VITE_ASSET__oN0sUAvT__"